export const amountFormatter = (value?: string) => {
  if (value === undefined) {
    return '';
  }
  return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
export const amountParser = (value?: string) => {
  if (!value) {
    return '';
  }
  const valueNoComma = `${value}`.replace(/\$\s?|(,*)/g, '');
  const pointGroups = valueNoComma.match(/^([0-9]*).?([0-9]*)/);
  const beforePoint = pointGroups?.[1] ?? 0;
  const afterPoint = pointGroups?.[2] ?? 0;

  return `${Number(`${beforePoint}.${afterPoint}`).toFixed(2)}`;
};
